import api from '../../../api';
import * as assignChat from '../../../modules/trader-chat/actions/assign-chat';

export function request(dispatch, { chatId }) {
    api.post('/chats/' + chatId + '/assign').then(
        () => dispatch(assignChat.finish(chatId)),
        (data) => dispatch(assignChat.error(chatId, data.errors))
    );
}

